import src from "IMAGE";
export default { src, width: 540, height: 540, blurWidth: 8, blurHeight: 8, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAYAAADED76LAAAARUlEQVR42q3NOw5AERSEYTfXYzE6S2E/KpWoicJe/QWJSmWSrzlnkhHiVX4YaKhF7ucHj4SKhgJ7FgIyBjoi3G1CrtuDTO7lBbrpzwIrAAAAAElFTkSuQmCC"};
